import { motion } from "framer-motion";
import { SPRING } from "@/lib/constants";

export function Reveal({ children, delay = 0, className = "", ...props }) {
  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ ...SPRING, delay }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <p
      className={`font-mono2 text-xs uppercase tracking-[0.25em] text-signal ${className}`}
    >
      {children}
    </p>
  );
}
